import { useMemo } from 'react';

import { SurveyTemplate } from '@dreryk/egabinet-survey-frontend-api';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { PreInterviewFormBean, PreInterviewFormController } from './PreInterviewForm.types';
import { QuestionAnswerTextarea } from './fields/QuestionAnswerTextarea';

export type PreInterviewFormRenderProps = Pick<PreInterviewFormController, 'formState' | 'handleSubmit'>;

type PreInterviewFormInitializer = () => PreInterviewFormBean;
type PreInterviewFormProps = {
   readonly preInterviewTemplate: SurveyTemplate;
   readonly children: (renderProps: PreInterviewFormRenderProps) => JSX.Element;
   readonly initializer?: PreInterviewFormInitializer;
};

export const PreInterviewForm = (props: PreInterviewFormProps): JSX.Element => {
   const { formState, handleSubmit, register } = useFormController<PreInterviewFormBean>(
      // eslint-disable-next-line react-hooks/exhaustive-deps
      useMemo(() => props.initializer?.(), [props.initializer])
   );

   return (
      <>
         <StyledFlex gap={24} direction={'column'} as={'form'} noValidate autoComplete={'off'}>
            {props.preInterviewTemplate.questions.map((question) => (
               <QuestionAnswerTextarea key={question.id} question={question} register={register} />
            ))}
         </StyledFlex>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </>
   );
};
